import Constants from "../../../components.constants.js"

export default {
    addToUploadList(state, payload) {
        if (!(payload["job_id"] in state.yetToUpload)) {
            state.yetToUpload[payload["job_id"]] = payload["uploader"];
            state.allJobs[payload["job_id"]] = payload["uploader"];
            state.allJobsToDisplayInPanel[payload["job_id"]] = payload["uploader"];
        }
    },
    startUpload(state) {
        if ((Object.keys(state.yetToUpload).length != 0) && (Object.keys(state.inProgress).length < Constants.maxParallelUploads)) {
            let uploader_job_id = Object.keys(state.yetToUpload).pop()
            state.inProgress[uploader_job_id] = state.yetToUpload[uploader_job_id];
            delete state.yetToUpload[uploader_job_id]
            state.inProgress[uploader_job_id].start();
        }
    },
    handleUploadExit(state, job_id) {
        if (job_id in state.inProgress) {
            delete state.inProgress[job_id];
        }
    },
    removeFailedFiles(state, jobId) {
        if (jobId in state.allJobs) {
            delete state.allJobs[jobId];
        }
        if (jobId in state.allJobsToDisplayInPanel) {
            delete state.allJobsToDisplayInPanel[jobId];
        }
    },
    emptyOldFiles(state) {
        Object.keys(state.allJobs).forEach(function(key) { delete state.allJobs[key]; });
        state.allJobs = {};
    },
    abortUpload(state, payload) {
        if (payload["job_id"] in state.inProgress) {
            try {
                state.inProgress[payload["job_id"]].abortPost(payload.data);
            } catch (ex) {
                console.error(`[upload][Store][error->${ex}]`)
            } finally {
                delete state.inProgress[payload["job_id"]];
            }
        }

        if (payload["job_id"] in state.yetToUpload) {
            try {
                state.yetToUpload[payload["job_id"]].abortPost(payload.data);
            } catch (ex) {
                console.error(`[upload][Store][error->${ex}]`)
            } finally {
                delete state.yetToUpload[payload["job_id"]];
            }
        }
        if (payload["job_id"] in state.allJobs) {
            delete state.allJobs[payload["job_id"]];
            delete state.allJobsToDisplayInPanel[payload["job_id"]];
        }
    }
};